import { useState } from "react";
import { Mail } from "lucide-react";
import { toast } from "sonner";
import { api } from "../lib/api";
import { Button } from "./ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";

export function PagheSend({ p, q }) {
  const [d, setD] = useState(null);
  const [busy, setBusy] = useState(false);
  const label = `${p.reparto} ${String(p.mese).padStart(2, "0")}/${p.anno}`;
  const open = async () => {
    setBusy(true);
    try { setD(await api(`/admin/shifts/paghe?${q}`)); } catch (e) { toast.error(e.message || "Anteprima non disponibile"); }
    setBusy(false);
  };
  const send = async () => {
    setBusy(true);
    try { const r = await api(`/admin/shifts/send-paghe?${q}`, { method: "POST" }); toast.success(`Riepilogo inviato a ${r.inviati.join(", ")}`); setD(null); } catch (e) { toast.error(e.message || "Invio non riuscito"); }
    setBusy(false);
  };
  const bad = d ? d.rows.filter((r) => r[r.length - 1] !== d.days).length : 0;
  return (
    <>
      <Button className="rounded-full bg-[var(--navy)]" onClick={open} disabled={busy} data-testid="shifts-send-paghe"><Mail className="w-4 h-4 mr-1" />{busy && !d ? "Preparazione…" : "Invia riepilogo al Resp. amministrativo"}</Button>
      <Dialog open={!!d} onOpenChange={(o) => { if (!o) setD(null); }}>
        <DialogContent className="max-w-6xl max-h-[90vh] overflow-y-auto" data-testid="paghe-preview">
          <DialogHeader><DialogTitle>Anteprima riepilogo paghe · {label}</DialogTitle></DialogHeader>
          {d && <>
            <p className={`text-sm ${bad ? "text-red-700 font-medium" : "text-slate-500"}`} data-testid="paghe-check">{bad ? `Attenzione: per ${bad} dipendenti il TOTALE giorni non corrisponde ai ${d.days} giorni del mese (righe in rosso).` : `Controllo superato: il TOTALE giorni corrisponde ai ${d.days} giorni del mese per tutti.`}{d.checks.length ? ` ${d.checks.length} differenze con le richieste approvate (vedi in fondo).` : ""}</p>
            <p className="text-xs font-semibold uppercase tracking-wide text-slate-500 pt-2">Giorno per giorno (P = permesso, L.104, ST = straordinario 07-23, STN = notturno 23-07)</p>
            <div className="overflow-auto max-h-[45vh] rounded-xl border">
              <table className="w-full text-xs" data-testid="paghe-grid">
                <thead className="sticky top-0"><tr>{d.grid_head.map((h) => <th key={h} className="bg-[var(--navy)] text-white px-2 py-2 font-semibold whitespace-nowrap">{h}</th>)}</tr></thead>
                <tbody>{d.grid.map((r, i) => (
                  <tr key={i} className={i % 2 ? "bg-slate-50" : ""}>{r.map((v, j) => <td key={j} className={`border-t px-2 py-1 whitespace-nowrap ${j ? "text-center" : `font-medium ${String(v).endsWith("Dom") ? "text-red-600" : "text-[var(--navy)]"}`}`}>{v}</td>)}</tr>))}
                </tbody>
              </table>
            </div>
            <p className="text-xs font-semibold uppercase tracking-wide text-slate-500 pt-2">Riepilogo del mese</p>
            <div className="overflow-x-auto rounded-xl border">
              <table className="w-full text-xs" data-testid="paghe-table">
                <thead><tr>{d.head.map((h) => <th key={h} className="bg-[var(--navy)] text-white px-2 py-2 font-semibold whitespace-nowrap">{h}</th>)}</tr></thead>
                <tbody>{d.rows.map((r, i) => (
                  <tr key={i} className={r[r.length - 1] !== d.days ? "bg-red-50" : i % 2 ? "bg-slate-50" : ""} data-testid={`paghe-row-${i}`}>
                    {r.map((v, j) => <td key={j} className={`border-t px-2 py-1.5 ${j ? "text-center" : "font-medium text-[var(--navy)] whitespace-nowrap"} ${j === r.length - 1 && v !== d.days ? "text-red-700 font-bold" : ""}`}>{v}</td>)}
                  </tr>))}
                </tbody>
              </table>
            </div>
            <p className="text-xs font-semibold uppercase tracking-wide text-slate-500 pt-2">Riscontro con le richieste approvate</p>
            {!d.checks.length ? <p className="text-sm text-green-700" data-testid="paghe-checks-ok">Nessuna differenza tra turni, ferie, permessi, L.104 e straordinari approvati.</p> : (
              <div className="overflow-auto max-h-[30vh] rounded-xl border border-amber-200" data-testid="paghe-checks">
                <table className="w-full text-xs"><thead className="sticky top-0"><tr>{["Dipendente", "Voce", "Giorno", "Differenza"].map((h) => <th key={h} className="bg-amber-100 text-amber-900 px-2 py-1.5 text-left">{h}</th>)}</tr></thead>
                  <tbody>{d.checks.map((r, i) => <tr key={i} className="border-t">{r.map((v, j) => <td key={j} className="px-2 py-1">{v}</td>)}</tr>)}</tbody></table>
              </div>)}
            <div className="flex flex-wrap justify-end gap-2">
              <Button variant="outline" className="rounded-full" onClick={() => setD(null)} data-testid="paghe-cancel">Annulla</Button>
              <Button className="rounded-full bg-[var(--navy)]" onClick={send} disabled={busy} data-testid="paghe-confirm-send"><Mail className="w-4 h-4 mr-1" />{busy ? "Invio…" : "Invia al Responsabile amministrativo"}</Button>
            </div>
          </>}
        </DialogContent>
      </Dialog>
    </>
  );
}
